﻿﻿export interface ICenterRequest {
    id: number;
    isNkrParticipant: boolean;
    isRdnParticipant: boolean;
    isAdpParticipant: boolean;
    xmVirtualOption: number;
    isFamilyVoucherParticipant: boolean;
    isAllIn: boolean;
    isAdpPartner: boolean;
    isDcnParticipant: boolean;
    isInDonorShield: boolean;
    isFollowUpParticipant: boolean;
    isMicrositeParticipant: boolean;
    preWorkupLabConfig: number;
}
